import { DataDictionary } from '@/api/index'

export function DataDictionaryMapping (data: any) {
  return DataDictionary.request({
    method: 'post',
    url: '/DataDictionaryMapping',
    data,
    iSFromData: true
  })
}
